<template>
  <div>
    <div>
      <h1 class="text-center">Top Spender Campaign</h1>
      <div>
        <List />
      </div>
    </div>
  </div>
</template>

<script>
import List from "./ListTopSpenderCampaign.vue";
export default {
  components: {
    List,
  },
};
</script>
